import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../src/pages/home";
import Registration from "../src/pages/registration";
import Login from "../src/pages/login";
import NewRegistration from "../src/pages/NewRegistration";
import UserDashBoard from "../src/pages/userDashboard"
import ClaimLoaneeIdentification from "../src/pages/claim-loanee-identification"
import DiseaseClaim from "../src/pages/diseaseClaim"
import DeathClaim from "../src/pages/deathClaim"
import LoanDetails from "../src/pages/LoanDetails"
import PreviewDiseaseClaim from '../src/pages/diseaseClaim/previewDiseaseClaim'
import PreviewDeathClaim from '../src/pages/deathClaim/previewDeathClaim'
import PrivateRoute from "./PrivateRoute"

function App() {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/login" element={<Login />} />
        <Route path="/new-registration" element={<NewRegistration />} />
        <Route path="/userDashboard" element={<PrivateRoute><UserDashBoard/></PrivateRoute>} />
        <Route path="/claimLoaneeIdentification" element={<PrivateRoute><ClaimLoaneeIdentification/></PrivateRoute>} />
        <Route path="/diseaseClaim" element={<PrivateRoute><DiseaseClaim/></PrivateRoute>} />
        <Route path="/deathClaim" element={<PrivateRoute><DeathClaim/></PrivateRoute>} />
        <Route path="/loanDetails" element={<PrivateRoute><LoanDetails/></PrivateRoute>} />
        <Route path="/previewDiseaseClaim" element={<PrivateRoute><PreviewDiseaseClaim/></PrivateRoute>}/>
        <Route path="/previewDeathClaim" element={<PrivateRoute><PreviewDeathClaim/></PrivateRoute>}/>

        {/* fallback route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
  );
}

export default App;
